export default "#### No\n\nGo straight to deciding on how to pay.\n";